// Sentry initialisation for the React frontend.
// Activates ONLY when REACT_APP_SENTRY_DSN is set at build time.
// Safe no-op in development.
import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production',
    release: process.env.REACT_APP_SENTRY_RELEASE || 'chathub-frontend@unknown',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_RATE || 0.1),
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
  });
}
